import * as preact from "preact";

import stores from "stores/stores";
import * as pushNotifications from "../pushNotifications";
import * as utils from "../shared/utils";

// Types for props
type Props = {
  appRouter: any;
};

// Types for state
type State = {
  currentPermission: string;
  thisDevice?:
    | {
        type: "notSupported";
      }
    | {
        type: "haveSubscription";
        subscription: any;
        device: string;
      }
    | {
        type: "noSubscription";
      };
  allSubscriptions?: Awaited<
    ReturnType<typeof pushNotifications.getServerSubscriptions>
  >;
};

const maxLengthOfEndpoint = 30;

/** Where a subscription's notifications go: the iOS app's are APNs device tokens */
const endpointOf = (
  subscriptionData: pushNotifications.ServerSubscription["subscriptionData"]
) =>
  "apnsToken" in subscriptionData
    ? `APNs ${subscriptionData.apnsToken}`
    : subscriptionData.endpoint;

// Bind generics to ExpandableProps and ExpandableState
export default class AdminDashboardView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      currentPermission: pushNotifications.currentPermission(),
    };

    this.initialize();
  }

  async initialize() {
    await this.getDeviceSubscriptions();
    await this.getServerSubscriptions();
  }

  async getServerSubscriptions() {
    const allSubscriptions = await pushNotifications.getServerSubscriptions(
      this.state.thisDevice
    );
    this.setState({
      allSubscriptions,
    });
  }

  async getDeviceSubscriptions() {
    const subscriptionStatus = await pushNotifications.getSubscriptionStatus();
    this.setState({
      thisDevice: subscriptionStatus,
    });
  }

  async sendNotification(path?: string) {
    await pushNotifications.sendNotification(
      path ? "test notification with path" : "test notification",
      path ? `test to path ${path}` : "test notification (no path)",
      1,
      path
    );
  }

  async enableWebNotifications() {
    if (pushNotifications.currentPermission() === "denied") {
      alert(
        "Notifications appear to be blocked for this site. " +
          "Please enable notifications for this site in your browser settings."
      );
      return;
    }

    await pushNotifications.enableWebNotifications();
    this.setState({
      currentPermission: pushNotifications.currentPermission(),
    });
  }

  async setBadgeCount(to: number) {
    navigator.setAppBadge(to);
  }

  render() {
    return (
      <div>
        <h1>Admin Page</h1>

        <h2>Links</h2>
        <ul>
          <li>
            <a href="/admin/coupons">Coupons</a>
          </li>
          <li>
            <a href="/admin/users">Users</a>
          </li>
          <li>
            <a href="/admin/chats">Chats</a>
          </li>
          <li>
            <a href="/admin/bookFeedback">Book Feedback</a>
          </li>
          <li>
            <a href="/admin/quadernoInbox">Quaderno Inbox</a>
          </li>
          <li>
            <a href="/admin/apiLogs">API Logs</a>
          </li>
          <li>
            <a href="/admin/revenue">Revenue</a>
          </li>
        </ul>

        <h2>App Badge</h2>
        <p>
          <button onClick={() => this.setBadgeCount(1)}>
            Set Badge Count to 1
          </button>
          <button onClick={() => this.setBadgeCount(0)}>
            Clear Badge Count
          </button>
        </p>

        <h2>Push Notifications</h2>

        <p>Current permission: {this.state.currentPermission}</p>
        <p>
          <button onClick={() => this.enableWebNotifications()}>
            Enable Web Notifications
          </button>
        </p>

        <h3>This device</h3>
        {this.state.thisDevice ? (
          this.state.thisDevice.type === "haveSubscription" ? (
            <ul>
              <li>Device: {this.state.thisDevice.device}</li>
              <li>
                Subscription endpoint:{" "}
                {utils.elide(
                  endpointOf(this.state.thisDevice.subscription),
                  maxLengthOfEndpoint
                )}
              </li>
            </ul>
          ) : (
            <p>No subscription</p>
          )
        ) : (
          <p>Fetching...</p>
        )}

        <h3>All Subscriptions</h3>
        <table style={{ marginTop: 10 }}>
          <tr>
            <th>Device</th>
            <th>Endpoint</th>
            <th>Matches this client</th>
          </tr>
          {this.state.allSubscriptions ? (
            this.state.allSubscriptions.map((subscription) => {
              const endpoint = endpointOf(subscription.subscriptionData);
              return (
                <tr>
                  <td>{subscription.device}</td>
                  <td title={endpoint}>
                    {utils.elide(endpoint, maxLengthOfEndpoint)}
                  </td>
                  <td>{subscription.thisDevice ? "Yes" : "No"}</td>
                </tr>
              );
            })
          ) : (
            <p>Fetching...</p>
          )}
        </table>

        <p>
          <button onClick={() => this.sendNotification()}>
            Send test notification
          </button>
          <button onClick={() => this.sendNotification("/learn")}>
            Send test to /learn
          </button>
          <button
            onClick={() =>
              stores.storedNotifications.deleteAllStoredNotifications()
            }
          >
            Clear all stored notifications
          </button>
        </p>
      </div>
    );
  }
}
